const minimum_amount_per_currency = {
	"AFN": 10.0,
	"ALL": 100.0,
	"DZD": 100.0,
	"USD": 1.0,
	"EUR": 1.0,
	"AOA": 100.0,
	"XCD": 1.0,
	"ARS": 10.0,
	"AMD": 100.0,
	"AWG": 1.0,
	"AUD": 1.0,
	"AZN": 1.0,
	"BSD": 1.0,
	"BHD": 1.0,
	"BDT": 100.0,
	"BBD": 1.0,
	"BYN": 5.0,
	"BZD": 1.0,
	"XOF": 500.0,
	"BMD": 1.0,
	"BTN": 100.0,
	"BOB": 7.0,
	"BAM": 1.0,
	"BWP": 10.0,
	"NOK": 10.0,
	"BRL": 5.0,
	"GBP": 1.0,
	"BND": 1.0,
	"BGN": 2.0,
	"BIF": 2000.0,
	"KHR": 4000.0,
	"XAF": 500.0,
	"CAD": 1.0,
	"CVE": 100.0,
	"KYD": 1.0,
	"CLP": 500.0,
	"CNY": 10.0,
	"COP": 5000.0,
	"KMF": 500.0,
	"NZD": 1.0,
	"CRC": 1000.0,
	"HRK": 10.0,
	"CUC": 1.0,
	"CZK": 25.0,
	"CDF": 2000.0,
	"DKK": 10.0,
	"DJF": 1000.0,
	"DOP": 50.0,
	"EGP": 20.0,
	"SVC": 8.75,
	"ERN": 15.0,
	"ETB": 50.0,
	"FKP": 1.0,
	"FJD": 2.0,
	"XPF": 100.0,
	"GMD": 50.0,
	"GEL": 3.0,
	"GHS": 5.0,
	"GIP": 1.0,
	"GTQ": 7.5,
	"GGP": 1.0,
	"GNF": 10000.0,
	"GYD": 200.0,
	"HTG": 150.0,
	"HNL": 25.0,
	"HKD": 7.8,
	"HUF": 300.0,
	"ISK": 100.0,
	"INR": 100.0,
	"IDR": 15000.0,
	"IRR": 42000.0,
	"IQD": 1500.0,
	"IMP": 1.0,
	"ILS": 3.5,
	"JMD": 150.0,
	"JPY": 100.0,
	"JEP": 1.0,
	"JOD": 1.0,
	"KZT": 500.0,
	"KES": 100.0,
	"KWD": 1.0,
	"KGS": 80.0,
	"LAK": 20000.0,
	"LBP": 15000.0,
	"LSL": 15.0,
	"LRD": 250.0,
	"LYD": 5.0,
	"CHF": 1.0,
	"LTL": 3.45,
	"MOP": 8.0,
	"MKD": 60.0,
	"MGA": 4000.0,
	"MWK": 1000.0,
	"MYR": 4.5,
	"MVR": 15.0,
	"MRO": 350.0,
	"MUR": 40.0,
	"MXN": 20.0,
	"MDL": 18.0,
	"MNT": 3500.0,
	"MAD": 10.0,
	"MZN": 50.0,
	"MMK": 2000.0,
	"NAD": 15.0,
	"NPR": 100.0,
	"ANG": 1.8,
	"NIO": 35.0,
	"NGN": 500.0,
	"KPW": 1000.0,
	"OMR": 1.0,
	"PKR": 250.0,
	"PAB": 1.0,
	"PGK": 5.0,
	"PYG": 7000.0,
	"PEN": 3.8,
	"PHP": 50.0,
	"PLN": 4.0,
	"QAR": 1.0,
	"RON": 5.0,
	"RUB": 100.0,
	"RWF": 1000.0,
	"SAR": 1.0,
	"RSD": 100.0,
	"SCR": 15.0,
	"SLL": 20000.0,
	"SGD": 1.0,
	"SBD": 8.0,
	"SOS": 1500.0,
	"ZAR": 10.0,
	"KRW": 1200.0,
	"SSP": 200.0,
	"LKR": 300.0,
	"SHP": 1.0,
	"STD": 25000.0,
	"SDG": 1000.0,
	"SRD": 30.0,
	"SZL": 15.0,
	"SEK": 10.0,
	"SYP": 13000.0,
	"TWD": 30.0,
	"TJS": 10.0,
	"TZS": 2000.0,
	"THB": 35.0,
	"UGX": 3500.0,
	"UAH": 40.0,
	"AED": 1.0,
	"UYU": 40.0,
	"UZS": 12000.0,
	"VUV": 120.0,
	"VEF": 100000.0,
	"VND": 25000.0,
	"WST": 3.0,
	"YER": 250.0,
	"YUN": 100.0,
	"ZMW": 20.0
};

export default minimum_amount_per_currency;